module.exports = __webpack_public_path__ + "static/media/ILIO.2beb85e6.svg";